import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {VotacionService} from '../votacion.service';
import {AlertaService} from 'src/app/util/alerta.service';

@Component({
  selector: 'sura-fin-votacion',
  templateUrl: './fin-votacion.component.html'
})
export class FinVotacionComponent implements OnInit {

  nombreFondo: string;
  idAsamblea: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _votacionService: VotacionService,
    private alertaService: AlertaService
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.idAsamblea = parseInt(params.get('idAsamblea'), 10);
      this._votacionService.obtenerNombreFondo(this.idAsamblea).then((rpta) => {
        if ((rpta instanceof Array && rpta.length === 1)) {
          this.nombreFondo = rpta[0];
        }
      }).catch(err => {
        this.alertaService.error(err);
      });
    });
  }

  finalizar() {
    this.router.navigate(['/validacion'], {queryParams: {}});
  }
}
